import { render, staticRenderFns } from "./ArticleDelete.vue?vue&type=template&id=880080a2&"
import script from "./ArticleDelete.vue?vue&type=script&lang=js&"
export * from "./ArticleDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports